import { render, staticRenderFns } from "./ConnectionList.vue?vue&type=template&id=99dd4078"
import script from "./ConnectionList.vue?vue&type=script&lang=js"
export * from "./ConnectionList.vue?vue&type=script&lang=js"
import style0 from "./ConnectionList.vue?vue&type=style&index=0&id=99dd4078&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports